"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withSlots = void 0;
var _react = _interopRequireDefault(require("react"));
require("../../decorators/FormInputLabel.css");
require("./InputWithSlots.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["prefix", "suffix"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var withSlots = exports.withSlots = function withSlots(WrappedComponent) {
  return function InputWithSlots(_ref) {
    var prefix = _ref.prefix,
      suffix = _ref.suffix,
      props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, prefix && /*#__PURE__*/_react["default"].createElement("div", {
      className: "input-with-props-prefix"
    }, prefix), /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, props, {
      className: ((0, _classnames["default"])(props.className), 'input-with-slots')
    })), suffix && /*#__PURE__*/_react["default"].createElement("div", {
      className: "input-with-props-suffix"
    }, suffix));
  };
};